/* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
import CustomDropdown from '../../reusable/dropdown';
import CustomModal from '../../modals';
import { fetchTwilioTokenThunk } from '../../../redux/thunks/sms';
import LabelWrapper from '../../wrapper/label';
import { Phone } from '@mui/icons-material';
import { red } from '../../../theme/themePrimitives';
import { setCallLogThunk } from '../../../redux/thunks/activity';
import { settingCallingStatus } from '../../../redux/slices/sms';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { Call, Device } from '@twilio/voice-sdk';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';

/**
 * @heading1: TransferDealModal
 * @paragraph:A modal component for transferring a deal to another stage or pipeline.
 * Users can select a pipeline and stage to transfer the deal.
 * @param: {boolean} open - Determines whether the modal is open.
 * @param: {function} onClose - Function to handle closing the modal.
 */

const StartACallModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const [callStatus, setCallStatus] = useState<string>('');
    const [makingACall, setMakingACall] = useState<boolean>(false);
    const [selectedOption, setSelectedOption] = useState<'apple' | 'android' | 'other' | null>(null);
    const [selectedNumber, setSelectedNumber] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [callInProgress, setCallInProgress] = useState(false);
    const [elapsedTime, setElapsedTime] = useState(0);
    const { calls } = useSelector((state: RootState) => state.sms);
    const [dialed, setDialed] = useState<string>('');
    const [callReference, setCallReference] = useState<Call | null>(null);

    const timerRef = useRef<NodeJS.Timeout | null>(null);

    const { contacts } = useSelector((state: RootState) => state.contact);
    const modalTitle = callInProgress ? 'Call in Progress' : selectedOption === 'apple' ? 'Apple & IPhone Devices' : selectedOption === 'android' ? 'PC & Android Devices' : selectedOption === 'other' ? 'Other' : 'Start a call';
    const handleSkypeCall = async () => {
        if (!selectedNumber) {
            return;
        }
        setIsLoading(true);
        // Find selected contact
        const contact = contacts.find((con) => con.id === selectedNumber);
        if (!contact) {
            return;
        }
        try {
            await dispatch(setCallLogThunk({ to: contact.contact_number, call_sid: '' })).unwrap();
        } catch (e) {
            //
        }
        if (selectedOption === 'other') {
            setCallInProgress(true);
            setIsLoading(false);

            // Start the timer
            timerRef.current = setInterval(() => {
                setElapsedTime((prev) => prev + 1);
            }, 1000);
            return;
        }
        // Construct Skype call link
        const skypeLink = `tel:${contact.contact_number}`;

        // Open Skype with the selected phone number
        window.open(skypeLink, '_self');
        setIsLoading(false);
    };

    const endCall = () => {
        setCallStatus('Call Disconnected');
        dispatch(settingCallingStatus({
            isCalling: false,
            status: 'Call Ended',
            device: null
        }));
        setElapsedTime(0);
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        setCallInProgress(false);
        if (callReference) {
            callReference?.disconnect();
        }
        if (calls.device) {
            calls.device?.disconnectAll();
        }
    };
    useEffect(() => {
        if (callReference) {
            callReference.on('accept', async () => {
                timerRef.current = setInterval(() => {
                    setElapsedTime((prev) => prev + 1);
                }, 1000);
                await dispatch(setCallLogThunk({
                to: contacts.find((c) => c.id === selectedNumber)?.contact_number as string,
                call_sid: callReference.parameters.CallSid
            })).unwrap();
                setCallStatus('connected');
            });
            callReference.on('disconnect', () => {
                toast.error('Call Disconnected', {
                    position: 'top-left',
                    theme: 'dark'
                });
                endCall();
            });
            callReference.on('error', (err) => console.log(`Call error: ${err}`));
        }
    }, [callReference]);

    useEffect(() => {
        window.addEventListener('beforeunload', endCall);
        return () => {
            window.addEventListener('beforeunload', endCall);
        };
    }, []);

    const sendDigitsHandler = (value: string) => {
        if (callReference) {
            callReference.sendDigits(value);
        }
    };

    const setupDevice = async () => {
        try {
            setMakingACall(true);
            setDialed('');
            // const response = await SMSApi.twilioCallToken(token, id ? parseInt(id as string, 10) : 0);
            const response = await dispatch(fetchTwilioTokenThunk(id ? parseInt(id as string, 10) : 0)).unwrap() as string;
            setMakingACall(false);
            setCallInProgress(true);
            const newDevice = await new Device(response, {
                // codecPreferences: ['opus', 'pcmu'] as Device.Options['codecPreferences']
            });
            newDevice.on('registered', () => console.log('Ready to make calls'));
            const res = await newDevice.connect({ params: { To: contacts.find((c) => c.id === selectedNumber)?.contact_number as string }});
            setCallReference(res);
            console.log(res);
            // await dispatch(setCallLogThunk({
            //     to: contacts.find((c) => c.id === selectedNumber)?.contact_number as string,
            //     call_sid: res.parameters.CallSid
            // })).unwrap();
            setCallStatus('Dialing...');
            res.on('accept', () => {
                    console.log('Call connected');
                    // dispatch(settingCallingStatus({
                    //     isCalling: true,
                    //     status: 'Connected...',
                    //     device: res
                    // }));
                });
            //     res.on('disconnect', () => {
            //         toast.error('Call Disconnected', {
            //             position: 'top-left',
            //             theme: 'dark'
            //         });
            //         endCall();
            //     });
            //     res.on('error', (err) => console.log(`Call error: ${err}`));
        } catch (err: unknown) {
            console.error('Token fetch failed:', err);
        }
    };

    const onCloseHandler = () => {
        endCall();
        onClose();
    };

    useEffect(() => {
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, []);

    return <CustomModal open={open} handleClose={isLoading ? () => null : onCloseHandler} title={modalTitle} isBig={selectedOption !== 'other'}>
        {
            makingACall
                ? <Box display="flex" alignItems="center" flexDirection="column" height="200px" justifyContent="center">
                    <CircularProgress />
                    <Typography variant="body2">Please Wait We are making a call...</Typography>
                </Box>
                : callInProgress
                    ? <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        py={5}
                        // px={4}
                        borderRadius={3}
                        textAlign="center"
                        bgcolor="background.paper"
                    >
                        <Box
                            bgcolor={red[300]}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            borderRadius="50%"
                            width={80}
                            height={80}
                            mb={3}
                        >
                            <Phone fontSize="large" sx={{ color: 'white' }} />
                        </Box>

                        <Typography variant="h5" fontWeight="700" sx={{ color: 'text.primary', mb: 1 }}>
                            {contacts.find((c) => c.id === selectedNumber)?.contact_name}
                        </Typography>

                        <Typography variant="subtitle1" sx={{ color: 'text.secondary', mb: 2 }}>
                            {contacts.find((c) => c.id === selectedNumber)?.contact_number}
                        </Typography>

                        <Typography variant="body2" sx={{ color: 'text.disabled', mb: 4 }}>
                            {callStatus === 'connected' ? `Connected: ${Math.floor(elapsedTime / 60)}:${(elapsedTime % 60).toString().padStart(2, '0')}` : callStatus}
                        </Typography>
                        <Box width="100%" maxWidth={300} mb={2}>
                            <Typography variant="subtitle1" align="center" sx={{ mb: 2, letterSpacing: 2 }}>
                                {dialed || '–'}
                            </Typography>
                            <Box
                                display="grid"
                                sx={{
                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                    gridGap: 2
                                }}
                            >
                                {['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'].map((digit) => (
                                    <Button
                                        key={digit}
                                        variant="outlined"
                                        size="large"
                                        disabled={!callReference || makingACall || !selectedNumber}
                                        onClick={() => { sendDigitsHandler(digit); setDialed(dialed + digit); }}
                                        sx={{ fontSize: '1.25rem', py: 2 }}
                                    >
                                        {digit}
                                    </Button>
                                ))}
                            </Box>
                            {/* <Typography variant="caption" color="text.secondary" align="center" mt={1}>
                            Tap any key to send DTMF
                          </Typography> */}
                        </Box>

                        <Button
                            variant="contained"
                            color="error"
                            onClick={endCall}
                            disabled={makingACall || !selectedNumber || !callReference}
                            sx={{
                                px: 5,
                                py: 1.2,
                                textTransform: 'none',
                                fontWeight: '600',
                                borderRadius: 3,
                                fontSize: '1rem',
                                boxShadow: 3,
                                width: '100%',
                                maxWidth: 260
                            }}
                        >
                            Hang Up
                        </Button>
                    </Box>
                    : selectedOption === 'android' || selectedOption === 'apple'
                        ? <Box>
                            <LabelWrapper label="Select the phone number you wish to call" />
                            <Box>
                                <CustomDropdown
                                    options={contacts.map((contact) => ({
                                        label: `${contact.contact_name} ${contact.contact_number}`,
                                        value: contact.id
                                    }))}
                                    value={selectedNumber}
                                    onChange={(e) => setSelectedNumber(parseInt(e.target.value as string, 10))}
                                    disabled={isLoading}
                                />
                            </Box>
                            <Box display="flex" gap={2}>
                                <Button fullWidth variant="outlined" color="secondary" disabled={isLoading} onClick={() => setSelectedOption(null)}>Previous</Button>
                                <Button fullWidth variant="contained" disabled={isLoading} onClick={handleSkypeCall}>Confirm</Button>
                            </Box>
                        </Box>
                        : selectedOption === 'other'
                            ? <Box>
                                <Box>
                                    <LabelWrapper label="Select the phone number you wish to call" />
                                    <Box>
                                        <CustomDropdown
                                            options={contacts.map((contact) => ({
                                                label: `${contact.contact_name} ${contact.contact_number}`,
                                                value: contact.id
                                            }))}
                                            value={selectedNumber}
                                            onChange={(e) => setSelectedNumber(parseInt(e.target.value as string, 10))}
                                            disabled={isLoading}
                                        />
                                    </Box>
                                    <Box display="flex" mt={2} gap={2}>
                                        <Button fullWidth variant="outlined" color="secondary" disabled={isLoading} onClick={() => setSelectedOption(null)}>Previous</Button>
                                        <Button fullWidth variant="contained" disabled={isLoading} onClick={setupDevice}>Place a Call</Button>
                                    </Box>
                                </Box>
                                {/* <LabelWrapper label="If you are operating on cross platform devices
                        to make calls (eg: Apple to android), open this page on your mobile device and easily make a call." />
                        <Box display="flex" gap={2}>
                            <Button fullWidth variant="outlined" color="secondary" disabled={isLoading} onClick={() => setSelectedOption(null)}>Previous</Button>
                            <Button fullWidth variant="contained" disabled={isLoading}>Copy Page Link</Button>
                        </Box> */}
                            </Box>
                            : <Box>
                                <Typography variant="subtitle1" color="textSecondary" fontWeight="600">Choose from the following.</Typography>
                                <Typography variant="subtitle2" color="textDisabled" mb={2}>Quickly make a call from your computer or from your mobile device.</Typography>
                                <Box display="flex" gap={1} mt={2} boxSizing="border-box">
                                    <Button variant="contained" color="primary" disabled={isLoading} onClick={() => setSelectedOption('apple')} fullWidth>
                                        Apple & IPhone Devices
                                    </Button>
                                    <Button variant="contained" color="primary" disabled={isLoading} onClick={() => setSelectedOption('android')} fullWidth>
                                        PC & Android Devices
                                    </Button>
                                    <Button variant="contained" color="primary" disabled={isLoading} onClick={() => setSelectedOption('other')} fullWidth>
                                        Via Twilio
                                    </Button>
                                </Box>
                            </Box>
        }
    </CustomModal>;
};

export default StartACallModal;